import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "font-bold text-big mb-14" }
const _hoisted_3 = { class: "font-bold text-medium mb-5 w-full" }
const _hoisted_4 = { class: "md:flex md:flex-col md:w-1/2" }
const _hoisted_5 = { class: "md:flex md:flex-col md:w-1/2" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mt-2 md:flex md:justify-start" }
const _hoisted_8 = { class: "mb-5 md:mb-0 md:w-1/2" }
const _hoisted_9 = { class: "font-bold text-medium mb-5" }
const _hoisted_10 = { class: "md:w-1/2" }
const _hoisted_11 = { class: "font-bold text-medium mb-5" }
const _hoisted_12 = { class: "md:flex flex-row justify-between md:pr-20" }
const _hoisted_13 = { class: "font-bold text-medium mb-5 w-full" }
const _hoisted_14 = { class: "flex flex-col w-full mx-4" }
const _hoisted_15 = { class: "flex flex-row w-full pb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, null, -1)
const _hoisted_17 = { class: "flex flex-row flex-1 font-semibold" }
const _hoisted_18 = { class: "flex w-1/5" }
const _hoisted_19 = { class: "flex w-1/5" }
const _hoisted_20 = { class: "flex w-1/5" }
const _hoisted_21 = { class: "flex w-1/5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-1/5" }, null, -1)
const _hoisted_23 = { class: "flex flex-col w-full mb-7" }
const _hoisted_24 = { class: "w-full font-semibold mb-3" }
const _hoisted_25 = { class: "text-regular font-bold text-primary-blue" }
const _hoisted_26 = { class: "text-small text-gray-9 mb-2" }
const _hoisted_27 = { class: "flex flex-row mb-4" }
const _hoisted_28 = { class: "text-small overflow-x-scroll pb-2" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "text-regular font-bold text-primary-blue" }
const _hoisted_31 = { class: "text-small text-gray-9 mb-2" }
const _hoisted_32 = { class: "flex flex-row" }
const _hoisted_33 = { class: "text-small overflow-x-scroll pb-2" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "text-center text-medium text-red-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_info_field = _resolveComponent("info-field")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_section_wrapper = _resolveComponent("section-wrapper")!
  const _component_subcustomer_list_item = _resolveComponent("subcustomer-list-item")!
  const _component_change_password_modal = _resolveComponent("change-password-modal")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_spinner, {
          key: 0,
          class: "mx-auto"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && Object.keys(_ctx.accountDetails).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.accountDetails?.company_name || "-"), 1),
          _createVNode(_component_section_wrapper, { class: "md:flex md:flex-row" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("account.account.title")), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_info_field, {
                  label: "account.account.name",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.contact_name || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, { label: "account.account.email" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.contact_email || "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_info_field, {
                  label: "account.secrets.title",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "uppercase text-primary-blue",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showSecretsModal = true), ["stop"])),
                      innerHTML: _ctx.$t('account.secrets.button')
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_default_button, {
                    class: "w-full md:w-auto",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showChangePasswordModal = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("account.settings.change_password")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "md:flex md:flex-row md:justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("account.company_details.title")), 1),
                _createVNode(_component_info_field, {
                  label: "account.company_details.name",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.company_name || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.contact_name",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.contact_name || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.contact_email",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.contact_email || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.client_id",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.id || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.tax_id",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.tax_id || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.registration_number",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.registration_number || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.company_details.url",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.website || "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("account.address.title")), 1),
                _createVNode(_component_info_field, {
                  label: "account.address.first_address_line",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.main_address?.address_first_line || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.address.second_address_line",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.main_address?.address_second_line || "-"), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_info_field, {
                    label: "account.address.city",
                    class: "w-1/3 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.accountDetails?.main_address?.city || "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_info_field, {
                    label: "account.address.postal_code",
                    class: "w-1/3 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.accountDetails?.main_address?.zip_code || "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_info_field, {
                    label: "account.address.state",
                    class: "w-1/3 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.accountDetails?.main_address?.state || "-"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_info_field, {
                  label: "account.address.country",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.country || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_info_field, {
                  label: "account.address.phone",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountDetails?.phone?.main || "-"), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          (_ctx.accountDetails?.sub_customers?.length)
            ? (_openBlock(), _createBlock(_component_section_wrapper, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("account.subcustomers.title")), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("account.subcustomers.name")), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("account.subcustomers.client_id")), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("account.subcustomers.city")), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("account.subcustomers.country")), 1),
                        _hoisted_22
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountDetails?.sub_customers, (subcustomer) => {
                      return (_openBlock(), _createBlock(_component_subcustomer_list_item, {
                        subcustomer: subcustomer,
                        key: `subcustomer_${subcustomer.id}_${new Date().getTime()}`
                      }, null, 8, ["subcustomer"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_modal, {
            modelValue: _ctx.showChangePasswordModal,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showChangePasswordModal) = $event)),
            "hide-buttons": true,
            size: "small"
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.settings.change_password")), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_change_password_modal, {
                onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChangePasswordModal = false))
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_modal, {
            size: "small",
            modelValue: _ctx.showSecretsModal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSecretsModal) = $event)),
            "hide-cancel-button": true,
            onConfirmClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSecretsModal = false))
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.secrets.title")), 1)
            ]),
            "confirm-button": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.secrets.confirm")), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("account.secrets.modal")), 1),
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("account.secrets.third_party.label")), 1),
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("account.secrets.third_party.description")), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.accountDetails.ongoing_secret), 1),
                  _createElementVNode("button", {
                    class: "text-primary-blue",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.copySecret(_ctx.accountDetails.ongoing_secret)), ["stop"])),
                    innerHTML: _ctx.$t('account.secrets.copy_button')
                  }, null, 8, _hoisted_29)
                ]),
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("account.secrets.direct.label")), 1),
                _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("account.secrets.direct.description")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.accountDetails.customer_api_secret), 1),
                  _createElementVNode("button", {
                    class: "text-primary-blue",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.copySecret(_ctx.accountDetails.customer_api_secret)), ["stop"])),
                    innerHTML: _ctx.$t('account.secrets.copy_button')
                  }, null, 8, _hoisted_34)
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !Object.keys(_ctx.accountDetails).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("account.general_error")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}